import { render, staticRenderFns } from "./award_text.vue?vue&type=template&id=dbd7e270&scoped=true&"
import script from "./award_text.vue?vue&type=script&lang=js&"
export * from "./award_text.vue?vue&type=script&lang=js&"
import style0 from "./award_text.vue?vue&type=style&index=0&id=dbd7e270&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd7e270",
  null
  
)

export default component.exports